export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-01.0996e43d.jpg";